import { Component, OnInit } from '@angular/core';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-equipments',
  templateUrl: './equipments.component.html',
  styleUrls: ['./equipments.component.css']
})
export class EquipmentsComponent implements OnInit {
    public setting?: Setting;

    public itemsListEquipments: Item[] = [];

    public grid?: GridOptions;

    public selectedBgEquipmentsMain: string = 'TOUCH';

    constructor(private stateService: StateService, private datatask: DataTaskService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(1364))[0];
    }

    private async loadEquipments() {
        this.itemsListEquipments = await this.datatask.Post(238);
    }

    private loadGrid() {
        if (!this.setting) return;

        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId(this.setting.view_id)
                .setLoadDataFunction({ method: this.setting.p2_datatask_keyno })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true })
                .setCustomToolbarButtons([{
                    name: 'add_new_equipmentedit',
                    text: 'add_new_equipmentedit',
                    tooltip: 'add_new_equipmentedit',
                    translateTooltip: true,
                    func: () => this.stateService?.go('equipmentedit', { equipment_id: '0' }),
                    icon: 'fas fa-plus',
                    cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
                    translate: true
                }]);
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadEquipments();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    searchtext: string;
    p2_datatask_keyno: number;
    view_id: string;
}
